import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MessageService } from 'src/app/message/services/message.service';
import { DeleteService } from 'src/app/shared/services/delete.service';
import { Card } from '../../model/card-implementations/card';
import { TranslateService } from '@ngx-translate/core';
import { ContainerType } from '../../../shared/models/container.types';
import {
    ConfirmationDialogComponent,
    ConfirmationDialogData,
} from '../../../shared/components/confirmation-modal/confirmation-dialog.component';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['../shared/card.component.scss'],
    standalone: false,
})
export class CardComponent implements OnInit {
    @Input()
    card: Card;
    @Output()
    deleteCardEvent: EventEmitter<string> = new EventEmitter<string>();

    constructor(
        private router: Router,
        private dialog: MatDialog,
        private messageService: MessageService,
        private deleteCardService: DeleteService,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.card.deleteCardService = this.deleteCardService;
        this.card.router = this.router;
        this.card.dialog = this.dialog;
    }

    onClickCardPicture(): void {
        // disable click redirect for robots and objects temporary
        if (!this.card.options?.isOnClickDisabled) {
            this.card.onCardPictureClick();
        }
    }

    openConfirmationDialog(): MatDialogConfig {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.width = '550px';
        dialogConfig.data = {
            headerTranslationKey: 'card.components.card.confirmation',
            confirmationQuestion: {
                translationKey: 'card.components.card.confirmationText',
                interpolateParameters: {
                    typeName: this.translate.instant(
                        this.card.cardTypeTranslationKey
                    ),
                    title: this.card.footer.title,
                },
            },
            confirmButtonTranslationKey: 'card.components.card.delete',
            rejectButtonTranslationKey: 'card.components.card.keep',
            transferData: true,
        } as ConfirmationDialogData;

        return dialogConfig;
    }

    onDeleteButtonClick(event) {
        event.stopPropagation();
        if (!this.card.options?.disableDeleteButton) {
            this.openDeletionDialog();
        }
    }

    openDeletionDialog() {
        // Ask user if element is to be deleted
        const dialogConfig: MatDialogConfig = this.openConfirmationDialog();

        this.dialog
            .open(ConfirmationDialogComponent, dialogConfig)
            .afterClosed()
            .subscribe((result) => {
                if (result) {
                    this.deleteCard();
                }
            });
        // If yes, delete object
    }

    private deleteCard() {
        this.card.deleteCard().subscribe({
            next: () => {
                this.reloadPageCard();
                this.messageService.displaySuccessMessage(
                    this.translate.instant(
                        'card.components.card.deleteSuccess',
                        {
                            name: this.translate.instant(
                                this.card.cardTypeTranslationKey
                            ),
                        }
                    )
                );
            },
            error: () => {
                this.messageService.displayErrorMessage(
                    this.translate.instant(
                        'card.components.card.deleteFailure',
                        {
                            name: this.translate.instant(
                                this.card.cardTypeTranslationKey
                            ),
                        }
                    )
                );
            },
        });
    }

    private reloadPageCard() {
        this.deleteCardEvent.emit(this.card.itemId);
    }

    protected readonly ContainerType = ContainerType;
}
